

export class LanguageUpdateInput implements ILanguageUpdateInput {
    /** The auto-generated id of the language master */
    languageId!: number;
    /** The language name with 255 character limit */
    languageName!: string;

    constructor(data?: ILanguageUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): LanguageUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface ILanguageUpdateInput {
    /** The auto-generated id of the language master */
    languageId: number;
    /** The language name with 255 character limit */
    languageName: string;
}

